

import Container from "./Container";
import Products from "./Products";

export default {
  plugins: {
    content: [Products],
    layout: [Container],
  },
};
